import { render } from "./InfoLegend.vue?vue&type=template&id=51105144"
import script from "./InfoLegend.vue?vue&type=script&lang=js"
export * from "./InfoLegend.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__